import { useEffect, useRef, useState } from "react";

// Polls the W3C Gamepad API. Exposes a throttled React state for display and a
// live ref (padRef) updated every animation frame for the control loop.
export function useGamepad() {
  const [state, setState] = useState({ connected: false, id: "", index: null, axes: [], buttons: [] });
  const padRef = useRef(null);

  useEffect(() => {
    let raf;
    let last = 0;
    const loop = (t) => {
      const pads = navigator.getGamepads ? navigator.getGamepads() : [];
      const gp = Array.from(pads).find((p) => p);
      if (gp) {
        const snap = {
          connected: true,
          id: gp.id,
          index: gp.index,
          axes: Array.from(gp.axes),
          buttons: gp.buttons.map((b) => ({ pressed: b.pressed, value: b.value })),
        };
        padRef.current = snap;
        if (t - last > 80) {
          last = t;
          setState(snap);
        }
      } else if (padRef.current) {
        padRef.current = null;
        setState({ connected: false, id: "", index: null, axes: [], buttons: [] });
      }
      raf = requestAnimationFrame(loop);
    };

    const onConnect = (e) => { padRef.current = { connected: true, id: e.gamepad.id, index: e.gamepad.index, axes: [], buttons: [] }; };
    window.addEventListener("gamepadconnected", onConnect);
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("gamepadconnected", onConnect);
    };
  }, []);

  return { state, padRef };
}
